import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { ProjectDeliveryStatusConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { ProjectDeliveryStatusService } from './api/projectDeliveryStatus.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ProjectDeliveryStatusApiModule {
    public static forRoot(configurationFactory: () => ProjectDeliveryStatusConfiguration): ModuleWithProviders<ProjectDeliveryStatusApiModule> {
        return {
            ngModule: ProjectDeliveryStatusApiModule,
            providers: [ { provide: ProjectDeliveryStatusConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ProjectDeliveryStatusApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ProjectDeliveryStatusApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
